/**
 * 2020/4/13 - 10:42
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 *
 */
import vCopy from './copy'
// 自定义指令
const directives = {
  copy: vCopy
}
// 批量注册指令
export default {
  install (Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key])
    })
  }
}
